// extracted by mini-css-extract-plugin
export default {"back-button__icon":"BackButton_back-button__icon__U5aVD","back-button__label":"BackButton_back-button__label__UCDja"};